import { render, staticRenderFns } from "./treatmentplanbase.vue?vue&type=template&id=05184518&"
import script from "./treatmentplanbase.vue?vue&type=script&lang=js&"
export * from "./treatmentplanbase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports